module.exports = __webpack_public_path__ + "static/media/SofiaProRegular.6bec5bc5.woff";